import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { filter, map } from 'rxjs/operators';
import { ProfileService } from '@services/profile.service';
import { ModalDialogService } from '@services/modal-dialog.service';
import { UnlockLessonModalComponent } from '../../components/modals/unlock-lesson-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EnrolledCourseGuard {

  private router = inject(Router);
  private profileService = inject(ProfileService);
  private modalService = inject(ModalDialogService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.loggedUser) {
      return this.router.createUrlTree(['/auth/login']);
    }


    const courseGuid = route.params.courseGuid;

    //todo: should be this or is owner
    // return this.profileService.loadEnrolledCourses()
    //   .pipe(
    //     map((list: any) => {
    //       return indexOf(list, courseGuid) > -1;
    //     }),
    //   );

    return true;

    return this.profileService.canReadCourse(courseGuid)
      .pipe(
        map((result: any) => {
          let isAllowed = result.value;
          if (!isAllowed) {
            this.showWarning(courseGuid);
            return false;
          }
          return true;
        }),
      );
  }

  private showWarning(courseGuid: string): void {
    this.modalService.showComponent(UnlockLessonModalComponent, {
      title: 'enrolled_course_guard.title',
      description: 'enrolled_course_guard.description',
      courseGuid: courseGuid
    }).pipe(filter(confirmed => confirmed === true))
      .subscribe();
  }

}
